import Vue from 'vue'
// import store from '../../store'

export default {
  saveSummaryDetails (data, consultationId) {
    let obj = {
      consultation: data
    }
    return Vue.http.patch(window.API_URL + 'doctors/consultations/' + consultationId, obj)
  },
  sendSummary (consultationId, componentKey) {
    let obj = {
      consultation_id: consultationId
    }
    return Vue.http.post(window.API_URL + 'doctors/consultations/' + consultationId + '/publish', obj, {componentKey: componentKey})
  },
  summaryNotNeeded (consultationId, componentKey) {
    let obj = {
      consultation_id: consultationId
    }
    return Vue.http.post(window.API_URL + 'doctors/consultations/' + consultationId + '/not_needed', obj, {componentKey: componentKey})
  }
}



// WEBPACK FOOTER //
// ./src/api/customer/summary.js